<template>
    <section
        ref="section24"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="27"></v-add-listing-head>
        <main
            class="relative flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <figure class="flex flex-col gap-11 md:w-full">
                <figure class="mx-auto flex w-full max-w-lg gap-3">
                    <div><v-icon icon="images-mode" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 text-heading-3-desktop">
                            Fotografije
                        </div>
                        <div class="text-body-regular text-black-40">
                            Naložili ste
                            <b class="text-black-78"
                                >{{ pictures.length }}/20</b
                            >
                            fotografij vaše nepremičnine. Naložite lahko JPG ali
                            PNG tipa fotografij. Velikost ne sme presegati 10 MB.
                        </div>
                    </div>
                </figure>
                <figure
                    ref="scrollContainer"
                    class="max-w-screen abrakadabra no-scrollbar overflow-x-scroll md:-mx-12"
                    @scroll="checkScrollPosition"
                >
                    <form
                        method="POST"
                        :action="routes.submitForm"
                        id="select-add-photos"
                        enctype="multipart/form-data"
                        class="mb-0 flex flex-col gap-4 md:flex-row md:gap-6"
                    >
                        <v-csrf-token></v-csrf-token>
                        <div
                            class="pictures-dropzone min-w-full max-w-lg"
                            v-if="pictures.length < 20"
                        >
                            <div
                                class="dropzone-container flex h-[240px] w-full items-center justify-center rounded-3xl bg-green-10 md:h-[21.5rem]"
                                :class="[tooLargeError ? 'border border-salmon-base': '', errors ? 'border border-salmon-base': '',]"
                                @dragover="dragover"
                                @dragleave="dragleave"
                                @drop="drop"
                            >
                                <input
                                    type="file"
                                    multiple
                                    id="fileInput"
                                    class="hidden"
                                    @change="onChange"
                                    ref="fileInput"
                                    accept=".jpg,.jpeg,.png"
                                />
                                <input
                                    class="hidden"
                                    type="number"
                                    name="pictures[]"
                                    :value="picture.id"
                                    v-for="picture in pictures"
                                    :key="picture.name"
                                />

                                <label for="fileInput" class="file-label">
                                    <div
                                        v-if="isDragging"
                                        class="flex flex-col items-center justify-center text-body-regular text-black-78"
                                    >
                                        Izpustite za začetek nalaganja
                                    </div>
                                    <div
                                        v-else
                                        class="flex flex-col items-center justify-center text-body-regular text-black-78"
                                    >
                                        <div>
                                            <v-icon
                                                icon="add-photo"
                                                class="mb-6 text-green-49"
                                            ></v-icon>
                                        </div>
                                        <div class="hidden lg:flex">
                                            Povlecite sliko sem za nalaganje
                                        </div>
                                        <div
                                            class="mb-6 mt-6 hidden text-small-text-regular text-black-40 lg:flex"
                                        >
                                            ali
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                class="button button--large cursor-pointer flex"
                                                @click="openFileUpload()"
                                            >
                                                <v-icon icon="folder"></v-icon>
                                                <label
                                                    >Izberite fotografije</label
                                                >
                                            </button>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div
                            class="pictures-preview-and-actions flex flex-col gap-4 md:flex-row md:gap-6"
                            v-if="pictures.length"
                        >
                            <figure
                                v-for="picture in pictures"
                                :key="picture.name"
                                class="group relative flex h-[15rem] items-center justify-center overflow-hidden rounded-2xl md:h-[21.5rem] md:w-[32rem] md:rounded-3xl"
                            >
                                <img
                                    class="preview-img min-h-full w-full object-cover"
                                    :src="picture.listing_image_url"
                                />
                                <!-- <div class="absolute bottom-4 left-4">
                                    {{ picture.name }}
                                    {{ Math.round(picture.size / 1000) + "kb" }}
                                </div> -->
                                <div class="absolute left-4 top-4">
                                    <button
                                        type="button"
                                        class="button pointer-events-none"
                                        v-if="
                                            picture.type == 'estate_image_cover'
                                        "
                                    >
                                        <v-icon icon="art-track"></v-icon>
                                        <label>Naslovna slika</label>
                                    </button>
                                    <button
                                        type="button"
                                        v-else
                                        class="button button--gray"
                                        @click="
                                            setPictureAsCover(
                                                pictures.indexOf(picture)
                                            )
                                        "
                                    >
                                        <v-icon icon="art-track"></v-icon>
                                        <label
                                            >Izberite za naslovno sliko</label
                                        >
                                    </button>
                                </div>
                                <div class="absolute bottom-4 right-4">
                                    <button
                                        class="button button--gray"
                                        type="button"
                                        @click="
                                            remove(pictures.indexOf(picture))
                                        "
                                        title="Remove file"
                                    >
                                        <v-icon icon="delete"></v-icon>
                                        <label>Odstrani</label>
                                    </button>
                                </div>
                            </figure>
                        </div>
                        <div
                            class="carousel__arrows pointer-events-none left-0 right-0 hidden w-full md:absolute md:top-[300px] md:flex"
                        >
                            <div
                                class="pointer-events-none z-[1] mx-auto flex w-full justify-between px-6 md:px-12"
                            >
                                <div
                                    class="carousel__arrow carousel__arrow--left pointer-events-auto left-2.5 flex h-[40px] w-[40px] touch-manipulation items-center justify-center rounded-full border-none bg-white p-0 shadow-search transition-opacity"
                                    :class="[
                                        'carousel__arrow carousel__arrow--left',
                                        hideLeftScroll
                                            ? 'opacity-0'
                                            : 'cursor-pointer',
                                    ]"
                                    @click="scroll('left')"
                                >
                                    <v-icon icon="angle-left"></v-icon>
                                </div>
                                <div
                                    class="carousel__arrow carousel__arrow--right pointer-events-auto right-2.5 flex h-[40px] w-[40px] touch-manipulation items-center justify-center rounded-full border-none bg-white p-0 shadow-search transition-opacity"
                                    :class="[
                                        'carousel__arrow carousel__arrow--right',
                                        hideRightScroll
                                            ? 'opacity-0'
                                            : 'cursor-pointer',
                                    ]"
                                    @click="scroll('right')"
                                >
                                    <v-icon icon="angle-right"></v-icon>
                                </div>
                            </div>
                        </div>
                    </form>
                </figure>
                <figure
                    class="mx-auto flex w-full max-w-lg gap-3"
                    v-if="tooLargeError"
                >
                    <div class="text-small-regular text-salmon">
                        Izbrana fotografija presega največjo dovoljeno velikost.
                        Prosimo izberite drugo fotografijo.
                    </div>
                </figure>
                <figure
                    class="mx-auto flex w-full max-w-lg gap-3"
                    v-if="errors"
                >
                    <div class="text-small-regular text-salmon">
                        Prišlo je do napake pri nalaganju, preverite da je datoteka slika.
                    </div>
                </figure>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-add-photos')"
                :class="[
                    'button button--md h-[48px] w-[240px] px-6',
                    validated ? '' : 'button button--gray',
                ]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },

    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },

    data() {
        return {
            isDragging: false,
            pictures: [],
            hideLeftScroll: true,
            hideRightScroll: false,
            errors: null,
            tooLargeError: null,
        };
    },
    mounted() {
        this.pictures = this.stepData.pictures;
        this.$nextTick(() => {
            this.checkScrollPosition();
            this.startObserving();
        });
    },
    computed: {
        validated() {
            if (this.pictures.length == 0) return false;

            return true;
        },
    },
    methods: {
        openFileUpload() {
            document.getElementById("fileInput").click()
        },
        submitForm(formId) {
            if (this.validated) document.getElementById(formId).submit();
        },
        async onChange(e) {
            e.preventDefault();
            /**
             * This has to be a asny await method so we can set the estae_image_cover to the first file submitted on multy drop
             */
            for await (const file of this.$refs.fileInput.files) {
                var formData = new FormData();
                formData.append("file", file);

                if (this.pictures.length == 0) {
                    formData.append("type", "estate_image_cover");
                } else {
                    formData.append("type", "estate_image");
                }

                await this.uploadFile(formData);
            }
        },
        async uploadFile(formData) {
            let response = axios
                .post(this.routes.uploadFile, formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                        "X-CSRF-TOKEN": this.$csrfToken,
                    },
                })
                .then(
                    (response) => {
                        this.pictures.push(response.data);
                    },
                    (error) => {
                        if (error.response.status == 413) {
                            this.tooLargeError = true;
                            setTimeout(() => { this.tooLargeError = false; }, 3000);
                        } else {
                            this.errors = error.response.data.errors;
                            setTimeout(() => { this.errors = false; }, 3000);
                        }
                    }
                );

            return response;
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.fileInput.files = e.dataTransfer.files;
            this.onChange(e);
            this.isDragging = false;
        },
        remove(pictureIndex) {
            let picture = this.pictures[pictureIndex];

            let formData = {
                file_id: picture.id,
            };

            axios
                .post(this.routes.deleteFile, formData, {
                    headers: {
                        "X-CSRF-TOKEN": this.$csrfToken,
                    },
                })
                .then(
                    (response) => {
                        this.pictures.splice(pictureIndex, 1);
                    },
                    (error) => {
                        console.log(error);
                    }
                );
        },
        setPictureAsCover(pictureIndex) {
            let picture = this.pictures[pictureIndex];

            let formData = {
                file_id: picture.id,
            };

            axios
                .post(this.routes.updateCoverImage, formData, {
                    headers: {
                        "X-CSRF-TOKEN": this.$csrfToken,
                    },
                })
                .then(
                    (response) => {
                        this.pictures = response.data;
                        //this.pictures.splice(pictureIndex, 0, response.data);
                        //this.pictures.splice(pictureIndex, 1);
                    },
                    (error) => {
                        console.log(error);
                        // TODO: @ANZE
                    }
                );
        },
        startObserving() {
            const element = this.$refs.scrollContainer;

            const observer = new MutationObserver((mutationsList, observer) => {
                for (let mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        this.checkScrollPosition();
                    }
                }
            });

            observer.observe(element, {
                attributes: false,
                childList: true,
                subtree: true,
            });
        },

        scroll(direction) {
            const element = this.$refs.scrollContainer;
            const amount = 536;
            const margin = 48;

            let newScrollPosition =
                element.scrollLeft + (direction === "left" ? -amount : amount);

            // Ensure user can't scroll beyond the content.
            newScrollPosition = Math.min(
                newScrollPosition,
                element.scrollWidth - element.offsetWidth - margin
            );

            element.scrollTo({
                left: newScrollPosition,
                behavior: "smooth",
            });
        },

        checkScrollPosition() {
            const element = this.$refs.scrollContainer;
            const margin = 48;

            this.hideLeftScroll = element.scrollLeft <= 0;
            this.hideRightScroll =
                element.scrollLeft >=
                element.scrollWidth - element.offsetWidth - margin + 1;
        },
    },
    beforeDestroy() {
        // if you've created a startObserving method,
        // make sure you disconnect the observer in a beforeDestroy hook
        if (this.observer) {
            this.observer.disconnect();
        }
    },
};
</script>
